import React from 'react';
import { RouteObject } from 'react-router-dom';

import Route from 'src/components/route';
import loadable from 'src/utils/loadable';
import { Center, Class, Fill, Split } from 'src/components/layout';
import { PATH } from 'src/constants/app';
import { ALL } from 'src/components/coreUI/Sider';

export default [
  {
    path: PATH.HOME,
    element: <Route.Authenticated />,
    children: [
      {
        index: true,
        element: <Center>{loadable(() => import('src/pages/Home'))}</Center>,
      },
      {
        path: PATH.ALL_COURSES,
        element: <Center />,
        children: [
          {
            path: ':class_id',
            element: loadable(() => import('src/pages/CourseOverview')),
          },
        ],
      },
      {
        path: PATH.MY_COURSES,
        element: <Center />,
        children: [
          {
            path: ':class_id',
            element: loadable(() => import('src/pages/CourseSubscription')),
          },
        ],
      },
      {
        path: PATH.ASSESSMENT,
        element: <Center />,
        children: [
          {
            path: ':class_id',
            children: [
              {
                index: true,
                element: loadable(() => import('src/pages/CourseAssessment')),
              },
            ],
          },
        ],
      },
      {
        path: PATH.CHECKOUT,
        element: <Center />,
        children: [
          {
            path: ':class_id',
            element: loadable(() => import('src/pages/Checkout')),
          },
        ],
      },
      {
        path: PATH.PAYMENT,
        element: <Center />,
        children: [
          {
            path: ':class_id',
            element: loadable(() => import('src/pages/PaymentProcess')),
          },
        ],
      },
      {
        path: PATH.PAYMENT_EXTENSION,
        element: <Center />,
        children: [
          {
            path: ':class_id',
            element: loadable(() => import('src/pages/PaymentExtension')),
          },
        ],
      },
      {
        path: PATH.PAYMENT_SUCCESS,
        element: <Center />,
        children: [
          {
            path: ':class_id',
            element: loadable(() => import('src/pages/PaymentSuccess')),
          },
        ],
      },
      {
        path: PATH.CLASS,
        element: <Class />,
        children: [
          {
            path: ':class_id',
            children: [
              {
                index: true,
                element: loadable(() => import('src/pages/CourseHome')),
              },
              {
                path: 'programme-bios',
                element: loadable(() => import('src/pages/ProgrammeBios')),
              },
              {
                path: 'homework',
                children: [
                  {
                    index: true,
                    element: loadable(() => import('src/pages/CourseHomework')),
                  },
                  {
                    path: ':class_topic_id',
                    element: loadable(
                      () => import('src/pages/CourseHomeworkDetail'),
                    ),
                  },
                ],
              },
              {
                path: 'notes',
                children: [
                  {
                    index: true,
                    element: loadable(() => import('src/pages/CourseNotes')),
                  },
                  {
                    path: ':class_topic_content_id',
                    element: loadable(
                      () => import('src/pages/CourseNoteDetail'),
                    ),
                  },
                ],
              },
              {
                path: 'discussions',
                children: [
                  {
                    index: true,
                    element: loadable(
                      () => import('src/pages/CourseDiscussion'),
                    ),
                  },
                  {
                    path: ':class_topic_content_id',
                    element: loadable(
                      () => import('src/pages/CourseDiscussionDetail'),
                    ),
                  },
                ],
              },
              {
                path: 'what-next',
                children: [
                  {
                    index: true,
                    element: loadable(() => import('src/pages/WhatNext')),
                  },
                ],
              },
              {
                path: 'modules',
                children: [
                  {
                    path: 'edit',
                    element: loadable(
                      () => import('src/pages/CurriculumEditor'),
                    ),
                  },
                  {
                    index: true,
                    element: loadable(() => import('src/pages/CourseModules')),
                  },
                ],
              },
              {
                path: ':class_topic_id/:class_topic_content_id',
                element: loadable(() => import('src/pages/ClassTopicContent')),
              },
              {
                path: ':class_topic_id/homework',
                element: loadable(() => import('src/pages/ClassTopicHomework')),
              },
              {
                path: ':class_topic_id/module_quiz',
                element: loadable(() => import('src/pages/ClassModuleQuiz')),
              },
              {
                path: ':week_topic_id/feedback',
                element: loadable(
                  () => import('src/pages/ClassSectionFeedback'),
                ),
              },
              {
                path: 'one_pager',
                children: [
                  {
                    index: true,
                    element: loadable(() => import('src/pages/ClassOnePager')),
                  },
                  {
                    path: 'create',
                    element: loadable(
                      () => import('src/pages/ClassOnePagerCreate'),
                    ),
                  },
                  {
                    path: ':pager_id',
                    element: loadable(
                      () => import('src/pages/ClassOnePagerDetail'),
                    ),
                  },
                  {
                    path: 'companies',
                    element: loadable(() => import('src/pages/Companies')),
                  },
                ],
              },
              {
                path: 'demo_day',
                children: [
                  {
                    index: true,
                    element: loadable(() => import('src/pages/DemoDayPager')),
                  },
                  {
                    path: 'create',
                    element: loadable(
                      () => import('src/pages/ClassOnePagerCreate'),
                    ),
                  },
                  {
                    path: ':pager_id',
                    element: loadable(
                      () => import('src/pages/DemoDayPagerDetail'),
                    ),
                  },
                  {
                    path: 'companies',
                    element: loadable(() => import('src/pages/Companies')),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: PATH.LIBRARY,
        element: <Split />,
        children: [
          {
            index: true,
            element: loadable(() => import('src/pages/Library')),
          },
          {
            path: ':id',
            element: loadable(() => import('src/pages/Library')),
          },
        ],
      },
      {
        path: PATH.DIRECTORY,
        element: <Split />,
        children: [
          {
            index: true,
            element: loadable(() => import('src/pages/Directory')),
          },
          {
            path: ':filter_id',
            element: loadable(() => import('src/pages/Directory')),
          },
          {
            path: `${ALL.all_questions}/:user_id`,
            element: loadable(() => import('src/pages/DirectoryDetail')),
          },
          {
            path: ':filter_id/:user_id',
            element: loadable(() => import('src/pages/DirectoryDetail')),
          },
        ],
      },
      {
        path: PATH.JOBS,
        element: <Split />,
        children: [
          {
            index: true,
            element: loadable(() => import('src/pages/Jobs')),
          },
        ],
      },
      {
        path: PATH.CONNECT,
        element: <Fill />,
        children: [
          {
            index: true,
            element: loadable(() => import('src/pages/Connect')),
          },
        ],
      },
      {
        path: PATH.FAQS,
        element: <Split />,
        children: [
          {
            index: true,
            element: loadable(() => import('src/pages/FAQs')),
          },
          {
            path: ':category_id',
            element: loadable(() => import('src/pages/FAQs')),
          },
          {
            path: `${ALL.all_questions}/:faq_id`,
            element: loadable(() => import('src/pages/FAQsDetail')),
          },
          {
            path: `:category_id/:faq_id`,
            element: loadable(() => import('src/pages/FAQsDetail')),
          },
        ],
      },
      {
        path: PATH.SETTING,
        element: <Split />,
        children: [
          {
            index: true,
            element: loadable(() => import('src/pages/Setting')),
          },
          {
            path: '',
            element: loadable(() => import('src/pages/Setting')),
          },
          {
            path: 'account',
            element: loadable(() => import('src/pages/Setting/MyAccount')),
          },
          {
            path: 'password',
            element: loadable(() => import('src/pages/Setting/Password')),
          },
          {
            path: 'billing',
            element: loadable(() => import('src/pages/Setting/Billing')),
          },
          {
            path: 'subscriptions',
            element: loadable(() => import('src/pages/Setting/Subscriptions')),
          },
          {
            path: 'notifications',
            element: loadable(() => import('src/pages/Setting/Notifications')),
          },
        ],
      },
      {
        path: PATH.TERM_AND_POLICY,
        element: <Center />,
        children: [
          {
            index: true,
            element: loadable(() => import('src/pages/TermAndPolicy')),
          },
        ],
      },
      {
        path: '*',
        element: (
          <Center>
            {loadable(() => import('src/components/applications/ErrorPage'))}
          </Center>
        ),
      },
    ],
  },
  {
    element: <Route.Restricted />,
    children: [
      {
        path: PATH.LOGIN,
        element: loadable(() => import('src/pages/Login')),
      },
    ],
  },
  {
    element: <Route />,
    children: [
      {
        path: PATH.RESET_PASSWORD,
        element: loadable(() => import('src/pages/ResetPassword')),
      },
    ],
  },
  {
    element: <Route.Restricted />,
    children: [
      {
        path: PATH.VERIFICATION,
        element: loadable(() => import('src/pages/Verification')),
      },
    ],
  },
  {
    element: <Route />,
    children: [
      {
        path: PATH.REGISTER,
        element: loadable(() => import('src/pages/Register')),
      },
    ],
  },
  {
    element: <Route />,
    children: [
      {
        path: PATH.HANDLE,
        element: loadable(() => import('src/pages/Handle')),
      },
    ],
  },
  {
    path: PATH.NOT_FOUND,
    element: <Center />,
    children: [
      {
        index: true,
        element: loadable(
          () => import('src/components/applications/ErrorPage'),
        ),
      },
    ],
  },
  {
    path: PATH.FORBIDDEN,
    element: <Center />,
    children: [
      {
        index: true,
        element: loadable(
          () => import('src/components/applications/ErrorPage'),
        ),
      },
    ],
  },
  {
    path: PATH.INTERNAL_SERVER_ERROR,
    element: <Center />,
    children: [
      {
        index: true,
        element: loadable(
          () => import('src/components/applications/ErrorPage'),
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Center />,
    children: [
      {
        index: true,
        element: loadable(
          () => import('src/components/applications/ErrorPage'),
        ),
      },
    ],
  },
] as RouteObject[];
